var _   = require('underscore');
var sw  = require('js/lib/sw');
var $   = require('js/sw-jquery/sw-jquery');

var _gaq = window._gaq = window._gaq || [];

var DATA_ACCOUNT_CODE = 'ga_account_code';
var DATA_VARIATION_KEY = 'ga_experiments';
var DATA_CUSTOM_VAR_2 = 'ga_custom_var_2';

// Initiate more trackers
function initiateTrackers() {
  _.each(sw.data[DATA_ACCOUNT_CODE], function(code, accountName) {

    if(!_.isUndefined(sw.data[DATA_CUSTOM_VAR_2])) {
      _gaq.push([accountName + '._setCustomVar',
        2,
        'swProductCategory',
        sw.data[DATA_CUSTOM_VAR_2]
      ]);
    }

    _gaq.push(
      [accountName + '._setAccount', code],
      [accountName + '._trackPageview']
    );
  });
}

// Initiate experiments
var experiments = sw.data[DATA_VARIATION_KEY];
if (!_.isEmpty(experiments)) {

  /**
   * @see https://developers.google.com/analytics/devguides/collection/gajs/experiments#pro-server
   */
  $.getScript('//www.google-analytics.com/cx/api.js', function() {  
    _.each(experiments, function(variationId, experimentId) {
      window.cxApi.setChosenVariation(variationId, experimentId);
    });

    initiateTrackers();
  });
} else {
  initiateTrackers();
}



module.exports = _gaq;
